module.exports = __webpack_public_path__ + "img/caseImg2.ce5e7b2c.svg";